"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEDULE_MLO_CALL_URL = exports.LO_GIFT_CARD_AWARD_AMOUNT_DOLLARS = exports.GUARANTEED_RATE_MORTGAGE_REFINANCE_AWARD_AMOUNT_DOLLARS = void 0;
const calendly_1 = require("../calendly");
exports.GUARANTEED_RATE_MORTGAGE_REFINANCE_AWARD_AMOUNT_DOLLARS = 250;
exports.LO_GIFT_CARD_AWARD_AMOUNT_DOLLARS = 250;
exports.SCHEDULE_MLO_CALL_URL = calendly_1.MloCalendlyUrl.DANIEL_SALTER;
